import React, { useEffect, useState } from 'react';
import { C2CModalInterface } from '../../../store/models/C2CModal.interface';
import Styles from '../index.module.scss';
import VoiceTemplate from '../containers/VoiceTemplate';

export type MapStateToPropsType = {
    C2CModal: C2CModalInterface
}

const MainTemplate: React.FC<MapStateToPropsType> = ({ C2CModal }) => {
    const [channel, setChannel] = useState<any>(null);
    const { modalSource, initialSchema } = C2CModal;


    useEffect(() => {
        // only Voice channels supported currently
        // selecting Voice by default
        setChannel('Voice')

        return () => {
            document.body.removeAttribute('style')
        }
    }, [])

    useEffect(() => {
        if(modalSource === 'LOGS'){
            setChannel('Voice')
        }
    }, [modalSource])


    useEffect(() => {
        // provide channel if that particular channel needs initial selection

        if (initialSchema) {
            if (initialSchema.channel) {
                setChannel(initialSchema.channel)
            }
        }
    }, [initialSchema])

    const renderScreen = () => {
        switch (channel) {
            case 'Voice':
                return <VoiceTemplate />
            case 'SMS':
                return <div></div>
            default:
                return null
        }
    }

    return (
        <div className={Styles.C2CmodalContainer}>

            {/* hiding the select channel option  */}

            {/* {
                modalSource === 'NEW_CONVERSATION' &&
                <Select
                    value={channel}
                    label={t('mainSelectChannel')}
                    placeholder={t('mainSelectChannel')}
                    className={Styles.mrgBtm}
                    onChange={(val: any) => setChannel(val)}
                    showBottomLabelSpace={false}
                    disabled
                >
                    {channels.map((item) => <SelectOption key={item.key} value={item.value}>{item.value}</SelectOption>)}
                </Select>
            } */}
            {
                renderScreen()
            }
        </div>
    )
}

export default MainTemplate